import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme();

// Augment the palette to include a blue color
declare module '@material-ui/core/styles/createPalette' {
    interface Palette {
        blue: {
            main: string;
        };
    }
    interface PaletteOptions {
        blue: {
            main: string;
        };
    }
}

declare module '@material-ui/core/styles/createPalette' {
    interface Palette {
        gradient: {
            from: string;
            to: string;
        };
    }
    interface PaletteOptions {
        gradient?: {
            from?: string;
            to?: string;
        };
    }
}

export default createMuiTheme({
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '2.4rem',
            fontWeight: 400,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 400,
        },
        h5: {
            fontWeight: 500,
            fontSize: 26,
            letterSpacing: 0.5,
        },
    },
    palette: {
        primary: {
            main: '#414C5F',
            dark: '#1F2937',
        },
        blue: {
            main: '#0881FD',
        },
        gradient: {
            from: '#1D2E3E',
            to: '#2B3F53',
        },
    },
    overrides: {
        MuiDrawer: {
            paper: {
                backgroundColor: '#18202c',
            },
        },
        MuiButton: {
            label: {
                textTransform: 'none',
            },
            contained: {
                boxShadow: 'none',
                '&:active': {
                    boxShadow: 'none',
                },
            },
        },
        MuiTabs: {
            root: {
                marginLeft: defaultTheme.spacing(1),
            },
            indicator: {
                height: 3,
                borderTopLeftRadius: 3,
                borderTopRightRadius: 3,
                backgroundColor: defaultTheme.palette.common.white,
            },
        },
        MuiTab: {
            root: {
                textTransform: 'none',
                margin: '0 16px',
                minWidth: 0,
                padding: 0,
                [defaultTheme.breakpoints.up('md')]: {
                    padding: 0,
                    minWidth: 0,
                },
            },
        },
        MuiIconButton: {
            root: {
                padding: defaultTheme.spacing(1),
            },
        },
        MuiTooltip: {
            tooltip: {
                borderRadius: 4,
                fontSize: '0.75rem',
            },
        },
        MuiDivider: {
            root: {
                backgroundColor: '#404854',
            },
        },
        MuiListItemText: {
            primary: {
                fontWeight: 400,
            },
        },
        MuiListItemIcon: {
            root: {
                color: 'inherit',
                marginRight: 0,
                '& svg': {
                    fontSize: 20,
                },
            },
        },
        MuiAvatar: {
            root: {
                width: 32,
                height: 32,
            },
        },
        MuiTable: {
            root: {
                // To have rounded edges when no toolbar is being used
                borderSpacing: 'none',
                borderCollapse: 'unset',
            },
        },
    },
    shape: {
        borderRadius: 8,
    },
    props: {
        MuiTab: {
            disableRipple: true,
        },
    },
    mixins: {
        toolbar: {
            minHeight: 48,
        },
    },
});
